module.exports = __webpack_public_path__ + "img/da.63c806e6.svg";